module.exports = __webpack_public_path__ + "static/img/avatar.d5f34781.png";